<template>
  <v-card flat class="transparent-search">
    <div class="search-container">
      <v-layout row wrap fluid v-if="route === 'Index'">
        <v-flex lg2 md2 sm12>
          <v-container>
            <v-dialog ref="dialog"
                      persistent
                      v-model="modal1"
                      lazy
                      full-width
                      width="290px"
                      :return-value.sync="booking.check_in">
              <template v-slot:activator="{ on }">
                <v-text-field v-on="on"
                              label="CHECK-IN"
                              v-model="booking.check_in"
                              readonly
                              solo
                              flat
                              class="earthwerk-font input-field"
                              background-color="rgba(255,255,255,0.9)"></v-text-field>
              </template>
              <v-date-picker v-model="booking.check_in"
                             :min="start_date"
                             scrollable>
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="modal1 = false" class="earthwerk-font">CANCEL</v-btn>
                <v-btn flat color="primary" @click="$refs.dialog.save(booking.check_in)" class="earthwerk-font">OK</v-btn>
              </v-date-picker>
            </v-dialog>
          </v-container>
        </v-flex>
        <v-flex lg2 md2 sm12>
          <v-container>
            <v-dialog ref="dialog1"
                      persistent
                      v-model="modal2"
                      lazy
                      full-width
                      width="290px"
                      :return-value.sync="booking.check_out">
              <template v-slot:activator="{ on }">
                <v-text-field v-on="on"
                              label="CHECK-OUT"
                              v-model="booking.check_out"
                              readonly
                              solo
                              flat
                              class="earthwerk-font input-field"
                              background-color="rgba(255,255,255,0.9)"></v-text-field>
              </template>
              <v-date-picker v-model="booking.check_out"
                             :min="booking.check_in"
                             @input="retrievePricingSchedule()"
                             scrollable>
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="modal2 = false" class="earthwerk-font">CANCEL</v-btn>
                <v-btn flat color="primary" @click="$refs.dialog1.save(booking.check_out)" class="earthwerk-font">OK</v-btn>
              </v-date-picker>
            </v-dialog>
          </v-container>
        </v-flex>
        <v-flex lg2 md2 sm12>
          <v-container>
            <guests class="earthwerk-font"></guests>
          </v-container>
        </v-flex>
        <v-flex lg2 md2 sm12>
          <v-container>
            <vehicle class="earthwerk-font"></vehicle>
          </v-container>
        </v-flex>
        <v-flex lg4 md4 sm12>
          <v-container>
            <v-btn block color="primary" dark @click="makeReservation()" class="earthwerk-font action-button">{{bookButton}}</v-btn>
          </v-container>
        </v-flex>
        <v-snackbar :multi-line="true"
                    :left="true"
                    :vertical="true"
                    :timeout="6000"
                    color="error"
                    v-model="snackbar">
          <span class="earthwerk-font">CHECK-IN AND CHECK-OUT DATES MUST BE PROVIDED</span>
          <v-btn flat @click="snackbar = false" class="earthwerk-font">CLOSE</v-btn>
        </v-snackbar>
      </v-layout>
    </div>
  </v-card>
</template>

<script>
  import Guests from './Guests'
  import Vehicle from './Vehicle'

  export default {
    name: 'Search',
    components: { Vehicle, Guests },
    data() {
      return {
        modal1: false,
        modal2: false,
        snackbar: false,
        start_date: this.$moment().format('YYYY-MM-DD'),
        route: this.$route.name,
        booking: {
          days: 0,
          check_in: '',
          check_out: '',
          currency: localStorage.getItem('currency')
        }
      }
    },
    computed: {
      currency: function () {
        return this.$store.state.CurrencyStore.browser_currency
      },
      bookButton: function () {
        var page = this.$route.name.split('.', 1)
        if (page[0] === 'Index') {
          return 'MAKE BOOKING'
        } else {
          return 'ADJUST BOOKING'
        }
      }
    },
    created() {
      if (localStorage.getItem('booking') !== null) {
        var booking = JSON.parse(localStorage.getItem('booking'))
        this.booking = booking
      }
      this.$store.dispatch('get_all_currencies')
    },
    methods: {
      storeVehicles: function () {
        localStorage.setItem('vehicle_data', JSON.stringify(this.allVehicles))
      },
      storeConservation: function () {
        localStorage.setItem('conservation_data', JSON.stringify(this.allConservationFees))
      },
      makeReservation: function () {
        if (this.booking.check_in === '' || this.booking.check_out === '') {
          this.snackbar = true
        } else {
          this.adjustDates(this.booking.check_in, this.booking.check_out)
          this.storeConservation()
          this.storeVehicles()
          this.$router.push({
            name: 'Reservation'
          })
        }
      },
      setCurrency: function (data) {
        this.booking.currency = data
        localStorage.setItem('currency', data)
        this.$store.state.CurrencyStore.browser_currency = data
      },
      putStartDate: function () {
        var date = this.booking.check_in
        date = this.$moment(date).format('YYYY-MM-DD')
        this.booking.check_in = date
      },
      putEndDate: function () {
        var date = this.booking.check_out
        date = this.$moment(date).format('YYYY-MM-DD')
        this.booking.check_out = date
        var a = this.$moment(this.$moment(this.booking.check_in).format('YYYY, MM, DD'))
        var b = this.$moment(this.$moment(this.booking.check_out).format('YYYY, MM, DD'))
        this.booking.days = b.diff(a, 'days')
      },
      retrievePricingSchedule: function () {
        let data = {
          check_in_date: this.booking.check_in,
          check_out_date: this.booking.check_out
        }
        this.$store.dispatch('get_conservation_fee_by_check_in_out_date', data)
      }
    }
  }
</script>

<style scoped>
  @font-face {
    font-family: 'Earthwerk';
    src: url('PizzaDude.dk-Earthwerk.otf') format('opentype');
    font-weight: normal;
    font-style: normal;
  }

  .transparent-search {
    background-color: rgba(255, 255, 255, 0.2) !important;
    backdrop-filter: blur(5px);
    border-radius: 12px !important;
    padding: 15px;
  }

  .search-container {
    margin: 0 auto;
    max-width: 1200px;
  }

  .earthwerk-font {
    font-family: 'Earthwerk', sans-serif;
    text-transform: uppercase;
    letter-spacing: 1px;
  }

  .input-field {
    font-size: 1.1rem !important;
  }

    .input-field > > > .v-label {
      font-family: 'Earthwerk', sans-serif !important;
      font-size: 0.9rem !important;
      opacity: 0.9 !important;
    }

  .action-button {
    border-radius: 6px !important;
    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
    font-weight: bold;
    height: 48px !important;
    font-size: 1.1rem;
    letter-spacing: 1.5px;
  }

  .v-btn {
    font-family: 'Earthwerk', sans-serif !important;
    text-transform: uppercase !important;
  }

  @media (max-width: 960px) {
    .transparent-search {
      padding: 10px;
    }

    .input-field {
      font-size: 1rem !important;
    }

    .action-button {
      font-size: 1rem;
    }
  }

  @media (max-width: 600px) {
    .transparent-search {
      padding: 8px;
    }

    .input-field {
      font-size: 0.9rem !important;
    }

    .action-button {
      font-size: 0.9rem;
      letter-spacing: 1px;
    }
  }
</style>
